// Vue
import Vue from 'vue';
import Router from 'vue-router';

// Vuex
import store from 'store';


// Services
import { checkTokenTimestamps } from 'utils/tokenService';

// Base
const NotFound = () => import(/* webpackChunkName: "page-base" */ 'views/base/404');
const Error = () => import(/* webpackChunkName: "page-base" */ 'views/base/Error');
const Mdlerror = () => import(/* webpackChunkName: "page-base" */ 'views/base/Mdlerror');
const Confirm = () => import(/* webpackChunkName: "page-base" */ 'views/base/Confirm');

// Top Level Pages
const Home = () => import(/* webpackChunkName: "page-base" */ 'views/Home');
const Terms = () => import(/* webpackChunkName: "page-base" */ 'views/Terms');
const Privacy = () => import(/* webpackChunkName: "page-base" */ 'views/Privacy');
const Notice = () => import(/* webpackChunkName: "page-base" */ 'views/Notice');
const Statement = () => import(/* webpackChunkName: "page-base" */ 'views/Statement');
const Sitemap = () => import(/* webpackChunkName: "page-base" */ 'views/Sitemap');
const Dfd = () => import(/* webpackChunkName: "page-base" */ 'views/Dfd');

// Questionnaire
const Support = () => import(/* webpackChunkName: "page-base" */ 'views/questionnaire/Support');
const SupportDetail = () => import(/* webpackChunkName: "page-base" */ 'views/questionnaire/SupportDetail');
const SafetyScreen = () => import(/* webpackChunkName: "page-base" */ 'views/questionnaire/SafetyScreen');

// Appointments
const Appointments = () => import(/* webpackChunkName: "page-base" */ 'views/appointment/Appointments');
const AppointmentType = () => import(/* webpackChunkName: "page-base" */ 'views/appointment/AppointmentType');
const Face2face = () => import(/* webpackChunkName: "page-base" */ 'views/appointment/Face2face');

// Auth
const Login = () => import(/* webpackChunkName: "page-base" */ 'views/auth/Login');
const Logout = () => import(/* webpackChunkName: "page-base" */ 'views/auth/Logout');
const Register = () => import(/* webpackChunkName: "page-base" */ 'views/auth/Register');
const RegisterSuccess = () => import(/* webpackChunkName: "page-base" */ 'views/auth/RegisterSuccess');
const RegisterVerification = () => import(/* webpackChunkName: "page-base" */ 'views/auth/RegisterVerification');
const AuthReset = () => import(/* webpackChunkName: "page-base" */ 'views/auth/Reset');
const AuthConfirm = () => import(/* webpackChunkName: "page-base" */ 'views/auth/Confirm');
const Profile = () => import(/* webpackChunkName: "page-base" */ 'views/auth/Profile');

// Provider
const Scheduler = () => import(/* webpackChunkName: "page-base" */ 'views/provider/Scheduler');
const Results = () => import(/* webpackChunkName: "page-base" */ 'views/provider/Results');
const ProviderSchedule = () => import(/* webpackChunkName: "page-base" */ 'views/provider/Schedule');
const ProviderAppointment = () => import(/* webpackChunkName: "page-base" */ 'views/provider/Appointment');
const ProviderQuery = () => import(/* webpackChunkName: "page-base" */ 'views/provider/Query');

// Messaging
const Messages = () => import(/* webpackChunkName: "page-base" */ 'views/messaging/Messages');

// Documents 
const Documents = () => import(/* webpackChunkName: "page-base" */ 'views/documents/Documents');

// Conversations
const Conversation = () => import(/* webpackChunkName: "page-base" */ 'views/conversations/Conversation');

// Services
const Services = () => import(/* webpackChunkName: "page-base" */ 'views/services/Services');
const ServicesSearch = () => import(/* webpackChunkName: "page-base" */  'views/services/ServicesSearch');

// About
const About = () => import(/* webpackChunkName: "page-base" */ 'views/About');

// Contact
const Contact = () => import(/* webpackChunkName: "page-base" */ 'views/Contact');

// Help
const OthersHelp = () => import(/* webpackChunkName: "page-base" */ 'views/help/OthersHelp');
const HelpMyself = () => import(/* webpackChunkName: "page-base" */ 'views/help/HelpMyself');
const Risk = () => import(/* webpackChunkName: "page-base" */ 'views/help/Risk');

// Contentful
const Contentful = () => import(/* webpackChunkName: "page-base" */ 'views/contentful/Contentful');
const Topics = () => import(/* webpackChunkName: "page-base" */ 'views/contentful/Topics');
const Topic = () => import(/* webpackChunkName: "page-base" */ 'views/contentful/Topic');
const Article = () => import(/* webpackChunkName: "page-base" */ 'views/contentful/Article');
const SearchResults = () => import(/* webpackChunkName: "page-base" */ 'views/contentful/SearchResults');

Vue.use(Router);

const routes = [
  {
    path: '*',
    name: 'notFound',
    component: NotFound,
    meta: {
      fullHeader: true,
      hideFooter: true,
    },
  },
  {
    path: '/dfd',
    name: 'dfd',
    component: Dfd,
  },
  {
    path: '/error',
    name: 'error',
    component: Error,
    meta: {
      fullHeader: false,
      hideFooter: false,
    },
  },
  {
    path: '/mdlerror',
    name: 'mdlerror',
    component: Mdlerror,
    meta: {
      fullHeader: false,
      hideFooter: false,
    },
  },
  {
    path: '/confirm',
    name: 'confirm',
    component: Confirm,
    meta: {
      fullHeader: false,
      hideFooter: false,
    },
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      fullHeader: true,
    },
  },
  {
    path: '/terms',
    name: 'terms',
    component: Terms,
    meta: {
      fullHeader: true,
    },
  },
  {
    path: '/privacy-policy',
    name: 'privacy',
    component: Privacy,
    meta: {
      fullHeader: true,
    },
  },
  {
    path: '/privacy',
    name: 'notice',
    component: Notice,
    meta: {
      fullHeader: true,
    },
  },
  {
    path: '/appointments',
    name: 'appointments',
    component: Appointments,
    meta: {
      fullHeader: true,
    },
  },
  {
    path: '/conversation',
    name: 'conversation',
    component: Conversation,
    meta: {
      fullHeader: true,
    },
  },
  {
    path: '/documents',
    name: 'documents',
    component: Documents,
    meta: {
      fullHeader: true,
    },
    children: [
      {
        path: '/documents/sent',
        name: 'documents-sent',
        component: Documents,
        meta: {
          fullHeader: true,
        },
      },
    ],
  },
  {
    path: '/statement-of-understanding',
    name: 'statement',
    component: Statement,
    meta: {
      fullHeader: true,
    },
  },

  // Sitemap
  {
    path: '/sitemap',
    name: 'sitemap',
    component: Sitemap,
    meta: {
      fullHeader: true,
    },
  },

  // Questionnaire
  {
    path: '/support',
    name: 'support',
    component: Support,
    meta: {
      hideFooter: true,
      messages: ['We\'re here to help you'],
    },
  },

  {
    name: 'support-detail',
    path: '/support/:id',
    component: SupportDetail,
    meta: {
      hideFooter: true,
    },
  },

  {
    name: 'safety-screen',
    path: '/safety-screen',
    component: SafetyScreen,
  },

  {
    name: 'appointment-type',
    path: '/appointment-type',
    component: AppointmentType,
  },

  {
    name: 'face-2-face',
    path: '/face2face/:id',
    component: Face2face,
    meta: {
      hideFooter: true,
      sidebar: true,
      messages: [
        'Great. Please answer just a few more questions to help us find the right counselor for you',
      ],
    },
  },

  // Statics
  {
    path: '/legal',
    name: 'legal',
    component: Services,
    meta: {
      fullHeader: true,
    },
  },
  {
    path: '/financial',
    name: 'financial',
    component: Services,
    meta: {
      fullHeader: true,
    },
  },
  {
    path: '/family',
    name: 'family',
    component: Services,
    meta: {
      fullHeader: true,
    },
  },
  {
    path: '/search-services',
    name: 'search-services',
    component: ServicesSearch,
    meta: {
      fullHeader: true,
    },
  },

  // About
  {
    path: '/about',
    name: 'about',
    component: About,
    meta: {
      fullHeader: true,
    },
  },

  // Contact
  {
    path: '/contact',
    name: 'contact',
    component: Contact,
    meta: {
      fullHeader: true,
    },
  },

  // Auth
  {
    name: 'login',
    path: '/log-in',
    component: Login,
    meta: {
      noAuth: true,
      fullHeader: true,
    },
  },
  {
    name: 'logout',
    path: '/log-out',
    component: Logout,
    meta: {
      noFooter: true,
      pinHeader: true,
      fullHeader: true,
    },
  },
  {
    name: 'auth-reset',
    path: '/password/forgot',
    component: AuthReset,
    meta: {
      fullHeader: true,
    },
  },
  {
    name: 'auth-confirm',
    path: '/password/reset/:token',
    component: AuthConfirm,
    meta: {
      fullHeader: true,
    },
  },
  {
    name: 'profile',
    path: '/profile/:profileSection?',
    component: Profile,
    meta: {
      sidebar: true,
      fullHeader: true,
    },
  },

  // Provider
  {
    name: 'scheduler',
    path: '/schedule',
    component: Scheduler,
    meta: {
      sidebar: true,
      hideFooter: true,
    },
    children: [
      {
        name: 'results',
        path: '/results',
        component: Results,
        meta: {
          sidebar: true,
          // hideFooter: true,
        },
      },
      {
        name: 'provider-schedule',
        path: '/provider-schedule',
        component: ProviderSchedule,
        meta: {
          sidebar: true,
          // hideFooter: true,
        },
      },
      {
        name: 'appointment',
        path: '/appointment',
        component: ProviderAppointment,
        meta: {
          sidebar: true,
          // hideFooter: true,
        },
      },
      {
        name: 'provider-query',
        path: '/provider-query',
        component: ProviderQuery,
        meta: {
          sidebar: true,
          // hideFooter: true,
        },
      },
      {
        name: 'register',
        path: '/register',
        component: Register,
        meta: {
          pinHeader: true,
          noNavigation: true,
          sidebar: true,
        },
      },
      {
        name: 'register-verification',
        path: '/register-verification',
        component: RegisterVerification,
        meta: {
          pinHeader: true,
          noNavigation: true,
          sidebar: true,
        },
      },
      {
        name: 'register-success',
        path: '/register-success',
        component: RegisterSuccess,
        meta: {
          pinHeader: true,
          noNavigation: true,
          sidebar: true,
          messages: ['Great. Give us a moment to submit your request'],
        },
      },
    ],
  },

  // Help
  {
    name: 'others-help',
    path: '/help-someone-else/:id',
    component: OthersHelp,
    meta: {
      hideFooter: true,
    },
  },
  {
    name: 'help-someone',
    path: '/help-someone-else',
    component: OthersHelp,
    meta: {
      hideFooter: true,
    },
  },
  {
    name: 'help-myself',
    path: '/help-myself',
    component: HelpMyself,
    meta: {
      hideFooter: true,
      messages: [
        'We’re sorry to hear you’re going through a tough time',
        'But we’re glad you reached out',
        'Help us understand a little more about what you’re going through',
      ],
    },
  },
  {
    name: 'risk',
    path: '/risk',
    component: Risk,
    meta: {
      hideFooter: true,
    },
  },

  // Messages
  {
    name: 'messages',
    path: '/messages',
    component: Conversation,
    meta: {
      sidebar: true,
      fullHeader: true,
    },
  },

  {
    name: 'messages-stages',
    path: '/messages/:id',
    component: Messages,
    meta: {
      hideFooter: true,
      fullHeader: true,
    },
  },

  // Contentful
  {
    name: 'contentful',
    path: '/topics',
    component: Contentful,
    meta: {
      pinHeader: true,
      sidebar: true,
      fullHeader: true,
    },
    children: [
      {
        name: 'topics',
        path: '/',
        component: Topics,
        meta: {
          pinHeader: true,
          fullHeader: true,
        },
      },
      {
        name: 'topic',
        path: '/topics/:topic',
        component: Topic,
        meta: {
          pinHeader: true,
          fullHeader: true,
        },
      },
      {
        name: 'article',
        path: '/topics/:topic/:article',
        component: Article,
        meta: {
          pinHeader: true,
          fullHeader: true,
        },
      },
      {
        name: 'search-results',
        path: '/topics-search',
        component: SearchResults,
        meta: {
          pinHeader: true,
          fullHeader: true,
        },
      },
    ],
  },
];

const router = new Router({ 
  mode: 'history',
  routes,
  base: sessionStorage.getItem('clientId'),
});

router.beforeEach((to, from, next) => {
  const meta = to.meta;

  const isAuth = meta.auth === true;
  const isNoAuth = meta.noAuth === true;

  const userAuthed = store.getters['auth/isAuthenticated'];
  const auth_token = localStorage.getItem('fueledAuthToken');

  const noOrg = localStorage.getItem('noOrg');

  // Handle initial authentication
  if (!userAuthed && auth_token) {
    store.dispatch('auth/storeRedirect', to.path);
    store.dispatch('appointment/requestAppointmentUpcoming');
    store.dispatch('auth/requestCurrentUser', {
      auth_token,
      redirect: true,
    });
    return false;
  }

  if (userAuthed && to.name === 'register') {
    store.dispatch('appointment/requestAppointmentUpcoming');
  }

  if (
    (noOrg && to.name === 'login') ||
    (noOrg && to.name === 'support') ||
    (noOrg && to.name === 'support-detail') ||
    (noOrg && to.name === 'about') ||
    (noOrg && to.name === 'topics') ||
    (noOrg && to.name === 'topic') ||
    (noOrg && to.name === 'article') ||
    (noOrg && to.name === 'search-results') ||
    (noOrg && to.name === 'legal') ||
    (noOrg && to.name === 'financial') ||
    (noOrg && to.name === 'family') ||
    (noOrg && to.name === 'contact')
  ) {
    next({ name: 'home' });
  } 

  if (localStorage.getItem('isRoot') && to.name === 'login') next({ name: 'home' });

  // Handle states that require auth for unauthed users
  if (isAuth && !userAuthed) {
    store.dispatch('auth/storeRedirect', to.path);
    next({
      name: 'login',
      query: {
        redirect: to.path,
      },
    });
    return false;
  }

  if (userAuthed) store.dispatch('appointment/requestRetrievePatient');

  // Handle states that require no auth for authed users
  if (isNoAuth && userAuthed) {
    next({
      name: 'home',
    });
    return false;
  }

  if ( checkTokenTimestamps() ) {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./client/router/index.js